import {ItemPickersContextProvider} from '@github-ui/item-picker'
import type {ReactNode} from 'react'

import {InputElementActiveContextProvider} from './InputElementActiveContext'
import {IssueViewerCommentsContextProvider} from './IssueViewerCommentsContext'

type IssueViewerContextProviderType = {
  children: ReactNode
}

export function IssueViewerContextProvider({children}: IssueViewerContextProviderType) {
  return (
    <IssueViewerCommentsContextProvider>
      <ItemPickersContextProvider>
        <InputElementActiveContextProvider>{children}</InputElementActiveContextProvider>
      </ItemPickersContextProvider>
    </IssueViewerCommentsContextProvider>
  )
}

try{ IssueViewerContextProvider.displayName ||= 'IssueViewerContextProvider' } catch {}